import { request } from '@/shared/api/request'

export const getEstablishedPostByCategoryCode = (data) => {
	return request({ url: 'dict/getEstablishedPostByCategoryCode', method: 'GET', params: data })
}